var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLynklogoWithoutText(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.94
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.6736 7.91336C13.0055 8.24852 13.004 8.79337 12.6702 9.13036L6.06821 15.7957C6.03151 15.8339 6.00874 15.8859 6.00858 15.9432C6.00842 16.0009 6.03121 16.0532 6.06823 16.0913C6.12511 16.1424 6.18319 16.1916 6.2424 16.2384C7.63599 17.3384 9.66139 17.2357 10.9509 15.9339L15.1853 11.6589C16.91 9.91779 16.9177 7.10255 15.2025 5.37088L12.5506 2.6933C12.4675 2.60954 12.3326 2.60991 12.2491 2.69413L10.0276 4.93682C9.94429 5.02106 9.94391 5.15736 10.0268 5.24112L12.6736 7.91336Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.22422 9.08666C3.89228 8.75149 3.89377 8.20664 4.22756 7.86966L10.8296 1.20437C10.8663 1.16611 10.8891 1.11412 10.8892 1.05683C10.8894 0.999103 10.8666 0.946856 10.8296 0.908711C10.7727 0.857572 10.7146 0.808437 10.6554 0.761623C9.26191 -0.338542 7.2365 -0.235601 5.94693 1.06611L1.71252 5.34113C-0.0121695 7.08223 -0.0198924 9.89747 1.69527 11.6291L4.34733 14.3067C4.43029 14.3905 4.5652 14.3901 4.64873 14.3059L6.87017 12.0632C6.95359 11.979 6.95396 11.8427 6.871 11.7589L4.22422 9.08666Z",
    fill: "white"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLynklogoWithoutText);
export default __webpack_public_path__ + "static/media/lynklogo-without-text.31e1e62a.svg";
export { ForwardRef as ReactComponent };